import React, { Component } from 'react';
import { FacebookProvider, Page } from 'react-facebook';
import { variable } from './Function';
import '../css/Footer.css';

class AppFooter extends Component {
  constructor() {
    super();
    this.BaseUrl = variable().BASE_URL;
    this.state = {
      about: { 
        history: this.BaseUrl + 'page.php?pid=1',
        ceo: this.BaseUrl + 'page.php?pid=6',
        staff: this.BaseUrl + 'page.php?pid=7'
      },
      service: {
        member: this.BaseUrl + 'page.php?pid=2',
        scheduleLoan: this.BaseUrl + 'uploads/document/4/20180820944567j2SNIA.pdf',
        example: this.BaseUrl + 'uploads/document/2/201805221549380nUbIba.pdf',
        schedule: this.BaseUrl + 'uploads/document/3/20180522155115z3KGD45.pdf',
        serviceLoan: this.BaseUrl + 'page.php?pid=3',
        info: this.BaseUrl + 'page.php?pid=4'
      },
      performance: this.BaseUrl + 'page.php?pid=26',
      account: this.BaseUrl + 'page.php?pid=19',
      contact: this.BaseUrl + 'contact_map.php',
      showFooter: false
    };
  }

  componentDidMount() {
    const Path = window.location.pathname;
    const url = Path.split('/');
    if ( url[2] === 'read' && url[3] === 'message' ) {
      this.setState({ showFooter: true })
    } else if ( url[2] === 'dashboard' || url[2] === 'share' || url[2] === 'deposit' || url[2] === 'loan' || url[2] === 'payment' || url[2] === 'guarantor' || url[2] === 'password' || url[2] === 'message' ) {
      this.setState({ showFooter: true })
    } else if ( typeof url[2] === 'undefined' || url[2] === '' || url[2] === 'register' ) {
      this.setState({ showFooter: true })
    }
  }

  render() {
    return (
      <div>
        { (this.state.showFooter) ?
            <div className="footer">
              <div className="ft-first">
                <div className="fix-content">
                  <div className="ft-menu">
                    <div className="ft-first-title">เมนู</div>
                    <ul>
                      <li><a href={this.BaseUrl}>หน้าแรก</a></li>
                      <li><a href={this.state.about.history}>เกี่ยวกับสหกรณ์</a></li>
                      <li><a href={this.state.service.member}>บริการสมาชิก</a></li>
                      <li><a href={this.state.performance}>ผลการดำเนินงาน</a></li>
                      <li><a href={this.state.account}>เลขที่บัญชีธนาคาร</a></li>
                      <li><a href={this.state.contact}>ติดต่อเรา</a></li>
                    </ul>
                  </div>
                  <div className="ft-contact">
                    <div className="ft-first-title">ติดต่อเรา</div>
                    <div className="br-content"><i className="fas fa-map-marker-alt i-icon"></i><div className="div-icon">ที่อยู่ 442 หมู่ที่ 6 ตำบลโพนทอง อำเภอเมือง จังหวัดกาฬสินธุ์ 46000</div></div>
                    <div className="br-content"><i className="fas fa-phone-volume i-icon"></i><div className="div-icon">โทรศัพท์ : 043-873666 , 043-873667 โทรสาร : 043-873668</div></div>
                    <div className="br-content"><i className="fas fa-hand-holding-usd i-icon"></i><div className="div-icon">การเงิน : 086-376-4712 สินเชื่อ : 087-681-0220 ทั่วไป : 094-481-2660</div></div>
                    <div className="br-content"><i className="fas fa-envelope i-icon"></i><div className="div-icon">อีเมล์ : webmaster@klscoop.or.th</div></div>
                    <div className="br-content"><i className="fab fa-line i-icon"></i><div className="div-icon">Line : klscoop</div></div>
                  </div>
                  <div className="ft-facebook">
                    <div className="ft-first-title">ติดตามเรา</div>
                    <div className="fb">
                      <FacebookProvider appId={variable().FacebookID}>
                        <Page href="https://www.facebook.com/KLSCOOP/" tabs="timeline" height="240" />
                      </FacebookProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fix-last">
                <div>สหกรณ์ออมทรัพย์สาธารณสุขกาฬสินธุ์ จำกัด</div>
                <div>Kalasin Public Health Savings Cooperative Limted.</div>
                <div>พัฒนาโดย บริษัท อัพบีน จำกัด</div>
              </div>
            </div>
          :
            null
        }
      </div>
    )
  }
}
export default AppFooter;